"use client";

export const getUserKnowsAboutShowMapButton = () => {
  if (typeof window === "undefined") return false;
  return localStorage.getItem("showMapButtonClick") === "true";
};

export const setUserKnowsAboutShowMapButton = () =>
  localStorage.setItem("showMapButtonClick", "true");
